__turbopack_context__.v({
  "hidden-desktop": "DashboardSwitcher-module-scss-module__wMgsva__hidden-desktop",
  "is-active": "DashboardSwitcher-module-scss-module__wMgsva__is-active",
  "nav-mask-phone": "DashboardSwitcher-module-scss-module__wMgsva__nav-mask-phone",
  "nav-mask-phone-icon": "DashboardSwitcher-module-scss-module__wMgsva__nav-mask-phone-icon",
  "phone-icon-new-wrapper": "DashboardSwitcher-module-scss-module__wMgsva__phone-icon-new-wrapper",
});
